"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendEventTypeWithIconUrl = exports.extendEventsWithCoords = exports.buildEventTypeUrl = exports.eventTypeIdToIconMap = void 0;
var eventMapCountries_1 = require("./eventMapCountries");
var eventTypeIdToIconMap = {
    ACADEMY: 'book',
    BEMER_SATURDAY: 'medkit',
    BUSINESS_BUILDING: 'chart-line',
    BUSINESS_BUILDING_TRAINING: 'chart-line',
    BUSINESS_PRESENTATION: 'tv-retro',
    BUSINESS_SEMINAR: 'briefcase',
    DISG_PERSONALITY: 'sliders-h',
    ENTREPRENEUR_DAYS: 'microphone-alt',
    FAIR: 'bullhorn',
    HEALTH_LECTURE: 'user-md',
    IN_HOUSE_FAIR: 'newspaper',
    LIM_WORKSHOP: 'adjust',
    LUNCH_AND_LEARN: 'bullhorn',
    MEDICAL_TRAINING: 'hospital',
    MED_LECTURE: 'heart',
    MED_START_UP: 'heart',
    MED_SYMPOSIUM: 'heart',
    MPC: 'medkit',
    PERSONALITY_TRAINING: 'child',
    PRESENTATION_TRANING: 'paint-brush',
    REFERENT_REFRESHER: 'street-view',
    REFERENT_TRAINING: 'street-view',
    SALES_TRAINING: 'bell',
    TRAINING_VET: 'paw',
    TRAIN_THE_TRAINER: 'american-sign-language-interpreting',
    ALL: 'dot-circle',
};
exports.eventTypeIdToIconMap = eventTypeIdToIconMap;
var buildEventTypeUrl = function (eventType) {
    return "https://res.cloudinary.com/bemergroup/image/upload/c_fit,h_80,e_colorize,co_rgb:1eb4e6/e_outline:outer:1,co_black/l_bemer-atomic-lib:icons:light:".concat(eventTypeIdToIconMap[eventType.id], ",c_fit,h_40,e_colorize,co_white,g_north,y_14/v1510479819/bemer-atomic-lib/icons/solid/map-marker.png");
};
exports.buildEventTypeUrl = buildEventTypeUrl;
var extendEventsWithCoords = function (events) {
    return events.map(function (event) {
        var _a, _b, _c;
        if (((_a = event.venue) === null || _a === void 0 ? void 0 : _a.lat) && ((_b = event.venue) === null || _b === void 0 ? void 0 : _b.lng)) {
            return event;
        }
        var matchingCountry = eventMapCountries_1.eventMapCountries.find(function (country) { var _a; return country.country_code === ((_a = event.venue) === null || _a === void 0 ? void 0 : _a.countryCode); });
        if (!matchingCountry) {
            console.warn("No country found for ".concat((_c = event.venue) === null || _c === void 0 ? void 0 : _c.countryCode, ". (Event ID \"").concat(event.id, "\")"));
            return event;
        }
        return __assign(__assign({}, event), { venue: __assign(__assign({}, event.venue), { lat: matchingCountry.lat, lng: matchingCountry.lng }) });
    });
};
exports.extendEventsWithCoords = extendEventsWithCoords;
var extendEventTypeWithIconUrl = function (eventTypeCategories) {
    return eventTypeCategories
        .flatMap(function (cat) { return cat.eventTypes; })
        .map(function (type) { return (__assign(__assign({}, type), { url: buildEventTypeUrl(type) })); });
};
exports.extendEventTypeWithIconUrl = extendEventTypeWithIconUrl;
